// Ritmo.
//
// MUDANÇA DE VALOR GRAVADO, de propósito: `TIMEFRAME` passa a gravar
// "Rápido" / "Moderado" / "Sem pressa" no lugar de "rapido" / "lento" /
// "default". Duas razões:
//
//  1. `projecao.js` (o card de projeção do VITA) casa o ritmo com a tabela
//     RITMOS por esses rótulos. Com "lento"/"default" nada batia e TODA
//     projeção caía no fallback de 0,5 kg/semana — o gráfico existia, mas
//     mentia para dois dos três ritmos.
//  2. O valor viaja para a IA como `TEMPO_OBJETIVO` (texto livre, ver
//     generateCompletePlan.js): "Moderado" diz mais que "default".
//
// Quem lê o campo tolera valor desconhecido (OffcanvasDadosClinicos cai no
// valor cru), então não há consumidor a quebrar.

import React, { useEffect, useState } from "react";

import { Opcoes } from "../widgets/Widgets.jsx";

const OPCOES = [
  { value: "Rápido", label: "Rápido", sub: "~0,8 kg/sem" },
  { value: "Moderado", label: "Moderado", sub: "~0,5 kg/sem" },
  { value: "Sem pressa", label: "Sem pressa", sub: "~0,25 kg/sem" },
];

const StepTimeframe = ({ setCanProceed, setStepData }) => {
  const [ritmo, setRitmo] = useState("");

  useEffect(() => {
    const valido = Boolean(ritmo);
    setCanProceed(valido);
    setStepData(valido ? { TIMEFRAME: ritmo } : null);
  }, [ritmo, setCanProceed, setStepData]);

  return <Opcoes opcoes={OPCOES} valor={ritmo} onSelecionar={setRitmo} nome="Ritmo" />;
};

export default StepTimeframe;
